export default __webpack_public_path__ + "static/media/guide-add-active.0b823211.svg";